import { AppConstants, UploadFileTypes, UserTypes } from '@constants';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import { TextField } from '@itz/react-cms-element';
import CropImageField from '@components/CropImageField';
import { Button, Form } from 'antd';
import { FormItemLayoutConf } from '@constants/formConfig';
import React, { useEffect, useState } from 'react';

// Port từ license-cms/source/src/compoments/account/ProfileForm.js (class BasicForm -> hook).
// Field/nhãn/chuỗi/validation theo NGUỒN. Bố cục dùng FormItemLayoutConf của nguồn.
//
// 🚨 KHÔNG gọi form.validateFields() BÊN TRONG validator (bẫy A1 của antd 5: onFinishFailed trả
//    errorFields rỗng, bấm Lưu im lặng). Thay bằng validate lại confirmPassword từ onValuesChange.
// Nguồn có uploadFileLogo nhưng KHÔNG render field logo -> không port phần đó; khi submit vẫn
// gửi logo = userData.logoPath đúng như componentDidMount của nguồn (setFieldValue('logo', ...)).
const ProfileForm = ({ loading, userData, onSubmit }) => {
    const [form] = Form.useForm();
    const [avatar, setAvatar] = useState('');
    const [avatarPath, setAvatarPath] = useState(userData?.avatar);
    const isEmployee = userData?.kind === UserTypes.EMPLOYEE;

    const { execute: executeUpFile } = useFetch(apiConfig.file.upload);

    useEffect(() => {
        form.setFieldsValue({ ...userData });
        setAvatarPath(userData?.avatar);
        setAvatar(userData?.avatar ? `${AppConstants.contentRootUrl}${userData.avatar}` : '');
    }, [userData]);

    const uploadFileAvatar = (file, onSuccess, onError) => {
        executeUpFile({
            data: { type: UploadFileTypes.AVATAR, file: file },
            onCompleted: (response) => {
                if (response.result === true) {
                    onSuccess();
                    setAvatarPath(response.data.filePath);
                    setAvatar(`${AppConstants.contentRootUrl}${response.data.filePath}`);
                }
            },
            onError: () => {
                onError && onError();
            },
        });
    };

    // Thay cho validateToConfirmPassword của nguồn: chạy NGOÀI validator để không dính bẫy A1.
    const handleValuesChange = (changedValues) => {
        if ('password' in changedValues && form.isFieldTouched('confirmPassword')) {
            form.validateFields(['confirmPassword']);
        }
    };
    // compareToPassword (nguồn): confirm khác password -> báo lỗi
    const compareToPassword = async (_, value) => {
        const newPassword = form.getFieldValue('password');
        if ((value || newPassword) && value !== newPassword) {
            return Promise.reject(new Error('Mật khẩu bạn nhập không khớp!'));
        }
        return Promise.resolve();
    };

    const handleFinish = (values) => {
        onSubmit({ ...values, avatar: avatarPath, logo: userData?.logoPath });
    };

    return (
        <Form
            {...FormItemLayoutConf}
            form={form}
            onFinish={handleFinish}
            onValuesChange={handleValuesChange}
            onFinishFailed={({ errorFields }) => console.warn('Không submit được:', errorFields)}
            initialValues={userData}
        >
            <CropImageField
                name="avatar"
                label="Hình đại diện"
                imageUrl={avatar}
                aspect={1 / 1}
                uploadFile={uploadFileAvatar}
                disabled={isEmployee}
            />
            <TextField
                name="username"
                label="Tài khoản"
                placeholder="Vui lòng nhập tài khoản"
                fieldProps={{ disabled: true }}
                rules={[{ required: true, message: 'Vui lòng nhập tài khoản' }]}
            />
            <TextField
                name="fullName"
                label="Họ và tên"
                placeholder="Vui lòng nhập họ và tên"
                fieldProps={{ disabled: isEmployee }}
                rules={[{ required: true, message: 'Vui lòng nhập họ và tên' }]}
            />
            <TextField
                type="password"
                name="oldPassword"
                label="Mật khẩu hiện tại"
                placeholder="Vui lòng nhập mật khẩu"
                rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]}
            />
            <TextField type="password" name="password" label="Mật khẩu mới" />
            <TextField
                type="password"
                name="confirmPassword"
                label="Xác nhận mật khẩu mới"
                rules={[{ validator: compareToPassword }]}
            />
            <Form.Item
                wrapperCol={{
                    xs: { span: 24, offset: 0 },
                    sm: { span: 16, offset: 8 },
                }}
            >
                <Button loading={loading} className="profile-form-button" type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ProfileForm;
